import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';

import { GameHud, GameHudProps, TTSQuestionPanel } from '../../../Organisms';
import {
  MemoryGameMainGroup,
  MemoryGameMainGroupProps,
} from '../../../Organisms/MemoryGameMainGroup/MemoryGameMainGroup';

import styles from './GameplayTemplate.module.css';

type GameplayTemplateProps = {
  gameHudProps: GameHudProps;
  memoryGameMainGroupProps: MemoryGameMainGroupProps;
};

const GameplayTemplate = ({
  gameHudProps,
  memoryGameMainGroupProps,
}: GameplayTemplateProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%',
        maxWidth: '768px',
        flexGrow: 1,
        padding: '1.25rem',
      }}
    >
      <GameHud
        {...{
          ...gameHudProps,
          onClickExpandInstruction: gameHudProps.instruction
            ? openModal
            : undefined,
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          width: '100%',
        }}
      >
        <MemoryGameMainGroup {...memoryGameMainGroupProps} />
      </div>

      <AnimatePresence>
        {isModalOpen && gameHudProps.instruction && (
          <motion.div
            className={styles.modalBackdrop}
            onClick={closeModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
              variants={{
                open: { opacity: 1, scaleX: 1, scaleY: 1 },
                closed: { opacity: 0, scaleX: 0.8, scaleY: 0 },
              }}
              initial="closed"
              animate="open"
              exit="closed"
              transition={{ duration: 0.3 }}
            >
              <TTSQuestionPanel
                onPressClose={closeModal}
                instruction={gameHudProps.instruction}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default GameplayTemplate;
